export class Blob { }